import { render } from "./ForgetPasswordByMobile.vue?vue&type=template&id=2296a938"
import script from "./ForgetPasswordByMobile.vue?vue&type=script&lang=js"
export * from "./ForgetPasswordByMobile.vue?vue&type=script&lang=js"

import exportComponent from "D:\\eazyc\\ezDev\\ECS-Cognitive\\cognitive-screening-mobile-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__